import React, { useState, Fragment } from "react";
import { PageConfigurationContextConsumer } from "./index";
import "./styles/upcoming-event-banner.css";
// @ts-ignore
import Pluralize from "react-pluralize";
import Megaphone from "./vectors/Megaphone";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const megaphoneIcon = require("./styles/megaphone.svg");

const UpcomingEventBanner = ({
  eventsCount,
  upcomingEventsView
}: {
  eventsCount: Number;
  upcomingEventsView: () => void;
}) => {
  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <div className="container">
            <div
              className="upcoming-banner-container"
              style={{ backgroundColor: pageConfiguration.secondaryColor }}
            >
              <div className="upcoming-banner-img-div">
                <Megaphone color={pageConfiguration.primaryColor} />
              </div>
              <div className="upcoming-banner-info-div">
                <p
                  className={`upcoming-banner-p1 ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.secondaryColor
                  )}`}
                >
                  <Pluralize singular="Upcoming event" count={eventsCount} />
                </p>
                <p
                  className={`upcoming-banner-p2 ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.secondaryColor
                  )}`}
                >
                  Pick any event to be notified when photos are uploaded
                </p>
              </div>
              <button
                className={`upcoming-banner-btn ${ContrastForegroundUtility.fgClass(
                  pageConfiguration.accentColor
                )}`}
                onClick={upcomingEventsView}
                style={{ backgroundColor: pageConfiguration.accentColor }}
              >
                Check it out
              </button>
            </div>
          </div>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default UpcomingEventBanner;
